var render = function render(){var _vm=this,_c=_vm._self._c;return _c('finance-document-page',{attrs:{"document-type":"payment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }